var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vgs-notifications",class:_vm.mode,attrs:{"role":this.labels.Notifications,"aria-label":this.labels.Notifications}},_vm._l((this.$root.get_notifications),function(item){return _c('Message',{key:item.Uuid,attrs:{"mode":"alert","headline":item.Title}},[_vm._v(_vm._s(item.Message))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }